/*@flow*/
import * as t from 'lib/t';

export default t.maybe(
  t.list(
    t.struct({
      day: t.Any,
      intervals: t.list(
        t.maybe(t.struct({ opening: t.String, closing: t.String }))
      ),
    })
  )
);
